import { render, staticRenderFns } from "./InternetSnackBar.vue?vue&type=template&id=0488fd40"
import script from "./InternetSnackBar.vue?vue&type=script&lang=js"
export * from "./InternetSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports